var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "columns is-centered is-vcentered is-mobile is-gapless" },
    _vm._l(_vm.networks, function (network) {
      return _c(
        "ShareNetwork",
        {
          key: network.network,
          staticClass: "column is-narrow",
          attrs: {
            network: network.network,
            url: _vm.sharing.url,
            title: _vm.sharing.title,
            description: _vm.sharing.description,
            "data-event-clicktext": network.network,
          },
        },
        [
          _c("span", { staticClass: "icon is-medium ml-3" }, [
            _c("i", { class: network.icon }),
          ]),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }